import { Component, ViewChild } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { messages } from '../../funciones/mensajes';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TemplateService } from '../../../services/proyecciones/plantilla/template.service';
import { firstValueFrom } from 'rxjs';
import { SelectTitleComponent } from '../../../components/select-title/select-title.component';
import { CatalogosService } from '../../../services/proyecciones/catalogos/catalogos.service';
import { CuentaContableService } from '../../../services/proyecciones/cuenta-contable/cuenta-contable.service';
import { InstitucionService } from '../../../services/proyecciones/institucion/institucion.service';
import { SucursalService } from '../../../services/proyecciones/sucursal/sucursal.service';
import { CookieService } from 'ngx-cookie-service';
import { IndicadoresService } from '../../../services/proyecciones/indicadores/indicadores.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { format } from 'path';
import { PeriodosSaldosService } from '../../../services/proyecciones/periodos-saldos/periodos-saldos.service';
// --- Validador de operaciones aritmeticas ---
function operationSyntaxValidator(control: FormControl) {
  const value = control.value?.trim();
  if (!value) return null;

  // Solo permitir números, operadores y paréntesis
  const validChars = /^[\d+\-*/()\s]+$/;
  if (!validChars.test(value)) {
    return { invalidCharacter: true };
  }

  // Verificar balance de paréntesis
  const stack: string[] = [];
  for (const char of value) {
    if (char === '(') stack.push(char);
    else if (char === ')') {
      if (!stack.pop()) return { unbalancedParentheses: true };
    }
  }
  if (stack.length > 0) return { unbalancedParentheses: true };

  // Verificar secuencias inválidas de operadores
  const invalidPatterns = [
    /\+\s*[\+\/*]/,     // + seguido de otro operador
    /-\s*[\+\/*]/,      // - seguido de otro operador
    /[*\/]\s*[\+\-*/]/, // * o / seguido de otro operador
    /^[*/]/,            // empieza con * o /
    /[+\-*/]$/,         // termina con operador
  ];

  for (const pattern of invalidPatterns) {
    if (pattern.test(value)) return { invalidOperatorSequence: true };
  }

  return null; //sintaxis valida
}
@Component({
  selector: 'app-config-catalogo',
  templateUrl: './config-catalogo.component.html',
  styleUrl: './config-catalogo.component.css',
})
export class ConfigCatalogoComponent {
  @ViewChild(SelectTitleComponent) titleSelect!: SelectTitleComponent;
  private instId = 1;
  public selectedFiles;
  public fileData = [];
  public inst = [];

  public plantilla;
  private  templateId = undefined;
  public dataPlantillas = [];  
  public nuevaPlantilla = {
    nombre: '',
    descripcion: '',
    institucion: '',
    templateid: ''
  };
  public eliminar: boolean = false; //Bandera que indica si la plantilla seleccionada es eliminable 
  public editarCuentas: boolean = false; //Bandera que indica si se pueden editar las cuentas de la plantilla 
  public tituloModal;
  public formPlantilla = new FormGroup({
    nombre: new FormControl('', [Validators.required]),
    descrip: new FormControl('', [Validators.required]),
    institucion: new FormControl('', [Validators.required])
  })
  public formValidacion = new FormGroup({
    id: new FormControl(''),
    nombre: new FormControl('', [Validators.required]),
    expresion: new FormControl('', [Validators.required,operationSyntaxValidator]),
  })

  public dataContable = [];
  public dataExtraCon = [];
  public dataSucursales = [];
  public dataCuentaContable = [];
  public dataValidaciones = [];
  private cuentasEditadas = [];
  private sucEditadas = [];
  public cuentasNuevas = [];
  public formContable: boolean;

  private catNivel = [1,2,3,4,5,6,7];
  public catTipo = [];

  public newContable = false;
  public newExtracon = false;
  public newSucursales = false;

  public dataExistente = {contable:false, extra: false, suc: false};
  public dataCargando = {contable:false, extra: false, suc: false};

  constructor(
    public cookies: CookieService,
    public dataService: DataService,
    private translate: TranslateService,
    private excelservices: ExcelService,
    private plantillas: TemplateService,
    private catalogo: CatalogosService,
    private cuentaContable: CuentaContableService,
    private instituciones: InstitucionService,
    private sucursales: SucursalService,
    private indicador: IndicadoresService,
    private periodosSaldos: PeriodosSaldosService,
  ){
    this.templateId = Number(cookies.get('templateId'));
    this.getInstituciones();
    this.getPlantillas();
    this.getTipoCuenta();
  }

  private async getPlantillas(){
    try{      
      const res = await firstValueFrom(this.plantillas.getTemplates());
      for(const d of res){
        this.dataPlantillas.push({
          id: d.templateid,
          nombre: d.nombre,
          descripcion: d.descripcion,
          institutionid:d.instituciones.length !== 0 ? d.instituciones[0].institutionid : 0,
          nombreInst:d.instituciones.length !== 0 ? d.instituciones[0].alias : '',
          activo: d.instituciones.length !== 0 ? d.instituciones[0].activo_relacion : null,
        })
      }
      if(this.templateId !== 0){
        var plantilla = this.dataPlantillas.filter(t => t.id === Number(this.templateId))[0];
        this.selectPlantilla(plantilla)
        this.titleSelect.selected = plantilla;
      }
    }catch(er){
      messages.errorMessageGraph(er);
    }
  }
  public async getInstituciones(){
    try{
      const res = await firstValueFrom(this.instituciones.getInstituciones());
      this.inst = res;
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }

  private async getTipoCuenta(){
    try{
      const res = await firstValueFrom(this.catalogo.getTipoCuenta());
      this.catTipo = res.map(i => ({clave:i.clavetipo, id: i.tipocuentaid}));      
    }catch(e){
      messages.errorMessageGraph(e);
    }
  }

  public async selectPlantilla(d) {
    this.dataExistente = {contable:false, extra: false, suc: false};
    this.newContable = false;
    this.dataContable = [];
    this.dataExtraCon = [];
    this.dataSucursales = [];
    this.dataCuentaContable = [];
    try{
      this.plantilla = d;
      this.cookies.set('templateId', this.plantilla.id, {path: '/'});
      //obtencion de cuentas contables
      const res = await firstValueFrom(this.cuentaContable.getCuentas(this.plantilla.id));
      if(res.length !== 0){
        const c = res.filter(i => i.tipoid !== this.catTipo.filter(i=> i.clave === 'E')[0].id)
        const e = res.filter(i => i.tipoid === this.catTipo.filter(i=> i.clave === 'E')[0].id)
        this.dataExistente.contable = c.length > 0 ? true : false;
        this.dataExistente.extra = e.length > 0 ? true : false;
        this.dataCargando.contable = c.length > 0 ? true : false;
        this.dataCargando.extra = e.length > 0 ? true : false;
        for(const r of c){
          this.dataContable.push({
            id: r.cuentaid,
            nivel: r.nivel,
            tipoCuenta: this.catTipo.filter(i=>i.id === r.tipoid)[0].clave,
            codigo: r.codigo,
            nombre: r.nombre,
            proyeccion: r.proyeccion,
            segmento: r.segmento,
          })
        }
        for(const r of e){
          this.dataExtraCon.push({
            id: r.cuentaid,
            nivel: r.nivel,
            tipoCuenta: this.catTipo.filter(i=>i.id === r.tipoid)[0].clave,
            codigo: r.codigo,
            nombre: r.nombre,
            proyeccion: r.proyeccion,
            segmento: r.segmento,
          })
        }
      }
      this.dataCuentaContable.push(...this.dataContable);
      this.dataCuentaContable.push(...this.dataExtraCon);
      //obtencion de sucursales
      const res2 = await firstValueFrom(this.sucursales.getSucursales(this.plantilla.institutionid));
      this.dataExistente.suc = res2.length > 1 ? true : false; 
      this.dataSucursales = res2.length !== 0 ? res2 : this.dataSucursales;
      this.postSucConsolidado();
      this.eliminarDisponible();
      //Obtencion de validaciones 
      const res4 = await firstValueFrom(this.cuentaContable.getValidaciones(this.plantilla.id));
      this.dataValidaciones = res4.validaciones;
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  public async eliminarDisponible(){
    //La validacion de si se puede eliminar una plantilla se realiza siempre y cuando no existan 
    //proyecciones de dicha plantilla
    try{
      const res = await firstValueFrom(this.periodosSaldos.getPeriodosTemplate(this.plantilla.id));
      this.eliminar = false;
    }catch(e){
      this.eliminar = true;
    }
    this.editarDisponible();
  }
  public async editarDisponible(){
    //Para verificar si se pueden editar o eliminar cuentas posteadas se valida si aun no 
    //existen indicadores relacionados a la plantilla seleccionado si no existen se puede editar
    try{
      const res = await firstValueFrom(this.indicador.getIndicadorTmp(this.plantilla.id));
      this.editarCuentas = false;
    }catch(e){
      this.editarCuentas = !this.eliminar ? true : false;
    }
  }
  public async guardarPlantilla(edit?){
    try{
      this.nuevaPlantilla.nombre = this.formPlantilla.controls['nombre'].value;
      this.nuevaPlantilla.descripcion = this.formPlantilla.controls['descrip'].value;
      this.nuevaPlantilla.institucion = this.formPlantilla.controls['institucion'].value;
      let res
      if(!edit){// se crea una nueva plantilla
        res = await firstValueFrom(this.plantillas.postTemplate(this.nuevaPlantilla));
        var aux = {
          id: res.template.templateid,
          nombre: res.template.nombre,
          descripcion: res.template.descripcion,
          institutionid: res.institution_template.institutionid,
          activo: true
        }
        this.dataPlantillas.push(aux)
        this.titleSelect.selected = aux;
        this.selectPlantilla(aux);
        messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'));
      }else{ // se modifica una plantilla existente
        this.nuevaPlantilla.templateid = this.plantilla.id;
        res = await firstValueFrom(this.plantillas.patchTemplate(this.nuevaPlantilla));
        this.dataPlantillas.filter(i => i.templateid === this.plantilla.id)[0] = {
          id: this.plantilla.id,
          nombre: this.nuevaPlantilla.nombre,
          descripcion: this.nuevaPlantilla.descripcion,
          institutionid: this.nuevaPlantilla.institucion,
        }
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'))
      }
    }catch(e){
      messages.errorMessageGraph(e);
    }    
    this.closeModal('nuevaPlantilla');
  }
  public async eliminarPlantilla(){
    try{
      //TODO aqui se va agregar la consulta para eliminar plantilla
      const res = await firstValueFrom(this.plantillas.deleteTemplate(this.plantilla.id));
      this.dataPlantillas = this.dataPlantillas.filter(i => i.id !== this.plantilla.id);
      this.dataContable = [];
      this.dataExtraCon = [];
      this.dataSucursales = [];
      this.dataCuentaContable = [];
      this.dataExistente = {contable:false, extra: false, suc: false};
      this.newContable = false;
      this.eliminar = false;
      this.plantilla = undefined;
      this.titleSelect.selected = undefined;
      // this.cookies.set('templateId', '0', {path: '/'});
      this.cookies.delete('templateId','/');
      messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
    }catch(e){
      messages.errorMessageGraph(e.error);
    }

  }
  private async postCuentaContable(data, tipoCuenta){
    try{
      const res = await firstValueFrom(this.cuentaContable.postCuenta(data, this.plantilla.id));
      this.dataExistente.contable = tipoCuenta === 'contable' ? true : this.dataExistente.contable;
      this.dataExistente.extra = tipoCuenta === 'extra' ? true : this.dataExistente.extra;
      messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'))
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }

  private async patchCuentaContable(cuenta, id){
    try{
      const res = await firstValueFrom(this.cuentaContable.patchCuenta(cuenta, id));
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }

  private isNumber(n){
    return typeof n === "number";
  }
  private isString(n){
    return typeof n === "string";
  }
  public async cargarArchivo(elem){
    let introdujo: any;
    introdujo = await Swal.fire({
      title: ''+ this.translate.instant('proyFinanciera.configCatalogo.selecArch'),
      text: "",
      input: 'file',
      html: `
        <div style="display:flex; flex-direction:column; gap:10px; align-items:center;">
          <a href="/assets/Plantillas/Plantilla-${elem}.xlsx" download="Plantilla-${elem}.xlsx"
            style="color:#1976d2; text-decoration:underline; cursor:pointer;">
            📥 Descargar plantilla
          </a>
        </div>
      `,      
      inputAttributes: {
        "accept": ".xlsx",
        "aria-label": "Upload your profile picture"
      },
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: this.translate.instant('menu.acep'),
      cancelButtonText: this.translate.instant('menu.cancel'),
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return this.translate.instant('proyFinanciera.configCatalogo.selecArch');
        }
        return '';
      }
    });
    
    this.selectedFiles = introdujo.value;
    var reader = new FileReader();
    reader.readAsDataURL(this.selectedFiles);
    reader.onload = (e) => {
      let data = reader.result;
      this.obtBuffer(data, elem);
    }
  }
  private async obtBuffer(data, elem){
    messages.messageSaving(this.translate.instant('proyFinanciera.configCatalogo.verificandoArch'), this.translate.instant('swal.espere'));
    const file = await fetch(data)
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const rawsData: any = XLSX.utils.sheet_to_json(worksheet, {header: 1});
    
    if(rawsData[0][0] == 'Nivel' || rawsData[0][0] == 'Tipo' || rawsData[0][0] == 'Codigo'){ // eliminamos el primer renglon de encabezados
      rawsData.shift();
    }  

    switch(elem){
      case 'Contable':
        if(this.verificarArchivoContable(rawsData) === 1){
          return;
        }
        //Archivo correcto
        for(const r of rawsData){      
          this.dataContable.push(
            {
              nivel: r[0],
              tipoCuenta: r[1].toUpperCase(),
              codigo: r[2],
              nombre: r[3],
              proyeccion: r[4].toUpperCase(),
              segmento: r.length > 5 ? r[5] : '',
            }
          )
        }
        this.dataCuentaContable.push(...this.dataContable);
        this.newContable = true;
        break;
      case 'Extracontable':
        if(this.verificarArchivoExtracontable(rawsData) === 1){
          return;
        }        
        //Archivo correcto
        for(const r of rawsData){      
          this.dataExtraCon.push(
            {
              nivel: null,
              tipoCuenta: r[0].toUpperCase(),
              codigo: r[1],
              nombre: r[2],
              proyeccion: r[3].toUpperCase(),
              segmento: ''
            }
          )
        }
        this.dataCuentaContable.push(...this.dataExtraCon);
        this.newExtracon = true;
        break;
      case 'Sucursales':
        if(this.verificarArchivoSucursal(rawsData) === 1){
          return;
        }        
        //Archivo correcto
        for(const r of rawsData){      
          this.dataSucursales.push(
            {
              codigo: r[0],
              nombre: r[1],
            }
          )
        }
        this.newSucursales = true;
        break;
    }
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('proyFinanciera.configCatalogo.correctoArch'));
  }
  // METODOS PARA LA CONFIGURACION CONTABLE 
  private verificarArchivoContable(data){      
    var p = 1;
    for(const row of data){
      if(row.length !== 0){
        //Nivel
        if(row[0] === undefined || !this.isNumber(row[0])){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorNivel');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        //Tipo
        if(row[1] === undefined || !this.isString(row[1]) || 
          !this.catTipo.some(t => t.clave.toUpperCase() === row[1].toUpperCase()) ){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorTipo');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        //Codigo
        if(row[2] === undefined ){// || !this.isNumber(row[2])){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorCodigo');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        //Cuenta-descripcion
        if(row[3] === undefined){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorCuenta');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        // Proyeccion
        if(row[4] === undefined || (row[4].toUpperCase() !== 'NO' && row[4].toUpperCase() !== 'SI') ){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorProyeccion');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        p++;
      }
    }
    return 0;
  }
  //TODO verficar si va a existir la posibilidad de eliminar o agregar una cuenta una vez que ya exista una base 
  // en base a la respuesta hay que modificar tambien el de eliminarExtracontable
  public async eliminarContable(id){
    if(this.dataExistente.contable){
      const result = await messages.confirmationSave(
        this.translate.instant('proyFinanciera.configCatalogo.eliminarCuenta'),
        this.translate.instant('acciones.continuar'),
        this.translate
      );
      if(result){
        //TODO aqui se va a agregar la consulta para eliminar el registro 
        messages.succesMessageGraph(this.translate.instant('swal.swalElimino'));
      }
    }
    var eliminado = this.dataContable.splice(id,1);
    const i = this.dataCuentaContable.findIndex(f => f.id === eliminado[0].id);
    this.dataCuentaContable.splice(i,1);
    // this.newContable = true;
    if(this.dataContable.length === 0){
      this.newContable = false;
    }
  }

  public agregarContable(){
    this.formContable = this.dataExistente.contable ? true : false;
    this.dataContable.push(
      {
        nivel: '',
        tipoCuenta: '',
        codigo: '',
        nombre: '',
        proyeccion: '',
        segmento: '',
      }
    );
    this.newContable = true;
  }
  public editarCuenta(item){
    if('id' in item){
      const index = this.cuentasEditadas.findIndex(r => r.id === item.id);

      if (index === -1) {// No está, lo agregamos
        this.cuentasEditadas.push({ ...item });
      } else {// Ya está, actualizamos el objeto
        this.cuentasEditadas[index] = { ...item };
      }
    }else{
      const camposValidos = this.validarCamposObligatorios(item);
      if(!camposValidos){
        return;
      }
      const index = this.cuentasNuevas.findIndex(r => r.codigo === item.codigo);
      if(index === -1){
        this.cuentasNuevas.push({...item});
      }else{
        this.cuentasNuevas[index] = {...item};
      }
    }    
    this.newContable = true;
  }
  private validarCamposObligatorios(item: any): boolean {
    const camposObligatorios = ['nivel', 'tipoCuenta', 'codigo', 'nombre', 'proyeccion'];

    for (const campo of camposObligatorios) {
      if (!item[campo] || item[campo].toString().trim() === '') {
        return false; // falta algún campo
      }
    }
    return true;
  } 
  public selectExtra(){

  }
  //se actualizan los registros en bd 
  public async guardarDataContable(tipoCuenta){
    messages.messageSaving(this.translate.instant('swal.agregandoInfo'), this.translate.instant('swal.espere'));
    const result = await messages.confirmationSave(
      this.translate.instant('proyFinanciera.configCatalogo.infoCorr'),
      this.translate.instant('acciones.continuar'),
      this.translate
    );
    if(result){
      try{
        if(this.cuentasEditadas.length == 0 && this.cuentasNuevas.length == 0){ //se crean las cuentas nuevas primera carga
          const data = tipoCuenta == 'contable' ? this.dataContable : this.dataExtraCon;
          this.postCuentaContable(data, tipoCuenta);
        }
        if(this.cuentasNuevas.length > 0){ // se agregan cuentas a las ya existentes
          const data = this.cuentasNuevas;
          const res = await firstValueFrom(this.cuentaContable.postCuenta(data, this.plantilla.id));
          this.dataCuentaContable.push(...data);
          this.cuentasNuevas = [];
          messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'));
        }
        if(this.cuentasEditadas.length > 0){// actualizar cuentas existentes
          for(const d of this.cuentasEditadas){
            let aux = {
              nivel: d.nivel,
              codigo: d.codigo,
              nombre: d.nombre,
              proyeccion: d.proyeccion,
              segmento: d.segmento,
              tipoid: this.catTipo.filter(i => i.clave === d.tipoCuenta)[0].id,
            }
            this.patchCuentaContable(aux, d.id);
            this.cuentasEditadas = [];
          }
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'))
        } 
        this.newContable = this.cuentasNuevas.length == 0 && this.cuentasEditadas.length == 0 ? false : true;
        this.newExtracon = this.newContable;
      }catch(e){
        messages.errorMessageGraph(e.error);
      }
    }
  }
  // FIN METODOS PARA CONFIGURACION CONTABLE

  // METODOS PARA LA CONFIGURACION EXTRACONTABLE 
  private verificarArchivoExtracontable(data){      
    var p = 1;
    for(const row of data){
      if(row.length !== 0){
        //Tipo
        if(row[0] === undefined || !this.isString(row[0]) || row[0].toUpperCase() !== 'E'){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorTipo');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        //Codigo
        if(row[1] === undefined || !this.isNumber(row[1])){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorCodigo');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        //Cuenta-descripcion
        if(row[2] === undefined){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorCuenta');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        // Proyeccion
        if(row[3] === undefined || (row[3].toUpperCase() !== 'NO' && row[3].toUpperCase() !== 'SI') ){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorProyeccion');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        p++;
      }
    }
    return 0;
  }
  
  public eliminarExtracontable(id){
    this.dataExtraCon.splice(id,1);
    if(this.dataExtraCon.length === 0){
      this.newExtracon = false;
    }
  }

  public agregarExtracontable(){
    this.dataExtraCon.push(
      {
        tipoCuenta: '',
        codigo: '',
        nombre: '',
        proyeccion: '',
      }
    );
    this.newExtracon = true;
  }
  // FIN METODOS PARA CONFIGURACION EXTRACONTABLE

  // METODOS PARA LA CONFIGURACION SUCURSALES 
  private verificarArchivoSucursal(data){      
    var p = 1;
    for(const row of data){
      if(row.length !== 0){
        //Codigo
        if(row[0] === undefined || !this.isNumber(row[0]) ){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorCodigo');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        //Cuenta-descripcion
        if(row[1] === undefined){
          let texto = this.translate.instant('proyFinanciera.configCatalogo.errorSucursal');
          messages.errorMessageGraph(texto+p);
          return 1;
        }
        p++;
      }
    }
    return 0;
  }
  
  public eliminarSucursal(id){
    this.dataSucursales.splice(id,1);
    if(this.dataSucursales.length === 0){
      this.newSucursales = false;
    }
  }

  public agregarSucursal(){
    if(this.dataSucursales.length<2){
      this.dataSucursales.push({codigo: '',nombre: ''});
    }else{ //agregar sucursal a la data existente
      Swal.fire({
        title: this.translate.instant('proyFinanciera.configCatalogo.nuevaSuc'),
        html: `
          <input id="codigo" type="number" class="swal2-input" placeholder="Código">
          <input id="nombre" type="text" class="swal2-input" placeholder="Nombre sucursal">
        `,
        confirmButtonColor: '#ff6b00',
        cancelButtonColor: '#B9B9BC',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('acciones.guard'),
        cancelButtonText: this.translate.instant('acciones.cancel'),
        preConfirm: () => {
          const cod = (document.getElementById('codigo') as HTMLInputElement).value;
          const nom = (document.getElementById('nombre') as HTMLInputElement).value;
          if (!cod || !nom) {
            return this.translate.instant('proyFinanciera.configCatalogo.datosInc');
          }
          return {cod, nom};
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try{
            var aux = {
              institutionid: this.plantilla.institutionid, 
              sucursales: [{codigo: result.value.cod, nombre:result.value.nom}]
            }
            const res = await firstValueFrom(this.sucursales.postSucursal(aux));
            this.dataSucursales.push({
              codigo: res.sucursales[0].codigo,
              institutionid: res.sucursales[0].institutionid,
              nombre: res.sucursales[0].nombre,
              sucursalid: res.sucursales[0].sucursalid
            })
            messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'));
          }catch(e){
            messages.errorMessageGraph(e.error.error);
          }
        }
      });
    }
    
    this.newSucursales = true;
  }
  public async postSucConsolidado(){
    try{
      if(!this.dataSucursales.some( i => i.codigo === '0' )){ //No existe la sucursal de consolidado y la posteamos
        const res = await firstValueFrom(this.sucursales.postSucursal({
          institutionid: this.plantilla.institutionid, 
          sucursales: [{codigo: 0, nombre: 'Consolidado', consolidado: true}]
        }));
        this.dataSucursales.push(res.sucursales[0]);
      }
      return;
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  //se actualizan los registros en bd 
  public async postDataSucursal(){
    try{
      if(this.sucEditadas.length === 0){//cuentas nuevas sin info previa
        //Se agrega un sucursal que funge para el consolidado y despues todas las obtenidas 
        messages.messageSaving(this.translate.instant('swal.agregandoInfo'), this.translate.instant('swal.espere'));
        var aux = this.dataSucursales.filter( i => i.nombre !== 'Consolidado');
        const res = await firstValueFrom(this.sucursales.postSucursal({sucursales: aux, institutionid: this.plantilla.institutionid}));
        const res2 = await firstValueFrom(this.sucursales.getSucursales(this.plantilla.institutionid));
        this.dataSucursales = res2;
      }else{//se actualiza info de sucursales
        messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
        for(const d of this.sucEditadas){
          const res = await firstValueFrom(this.sucursales.patchSucursal(d, d.sucursalid));
        }
      }
      this.newSucursales = false;
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'))
    }catch(e){
      messages.errorMessageGraph(e.error);
    }
  }
  public editarSucursal(item){
    this.newSucursales = true;
    const index = this.sucEditadas.findIndex(r => r.sucursalid === item.sucursalid);

    if (index === -1) {// No está, lo agregamos
      this.sucEditadas.push({ ...item });
    } else {// Ya está, actualizamos el objeto
      this.sucEditadas[index] = { ...item };
    }
  }
  // FIN METODOS PARA CONFIGURACION SUCURSALES

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }

  public modalPlantilla(edit?){
    this.tituloModal = edit ? this.translate.instant('proyFinanciera.configCatalogo.editPlanti') : this.translate.instant('proyFinanciera.configCatalogo.nuevaPlanti');
    this.formPlantilla.reset();
    if(edit){
      this.formPlantilla.patchValue({
        nombre: this.plantilla.nombre,
        descrip: this.plantilla.descripcion,
        institucion: this.inst.filter( i => i.id == this.plantilla.institutionid)[0].id,
      })
      this.formPlantilla.get('institucion')?.disable();
    }
    document.getElementById('nuevaPlantilla')!.style.display = 'block';
  }
  public modalValidacion(){
    this.formValidacion.reset();
    this.tituloModal = this.translate.instant('proyFinanciera.configCatalogo.addValidacion')
    document.getElementById('nuevaValidacion')!.style.display = 'block';
  }
  public closeModal(modal) {
    document.getElementById(modal)!.style.display = 'none';
  }
  public async guardarValidacion(){
    if(this.cuentasValidas()){
      try{
        var id = this.formValidacion.controls['id'].value;
        var nombre= this.formValidacion.controls['nombre'].value;
        var expresion= this.formValidacion.controls['expresion'].value;
        if(id){// editar validacion
          const res = await firstValueFrom(this.cuentaContable.patchValidacion(Number(id),nombre,expresion));
          const item = this.dataValidaciones.find(i => i.validacionesid === Number(id));
          if (item) {
            item.description = nombre;
            item.expresion = expresion;
          }          
          this.closeModal('nuevaValidacion');
          messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
        }else{ // crear validacion      
          const res = await firstValueFrom(this.cuentaContable.postValidacion(nombre, expresion, this.plantilla.id));
          this.dataValidaciones.push({
            description: nombre,
            expresion: expresion,
            id: res.validacionesid,
          });
          this.closeModal('nuevaValidacion');
          messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'));
        }
      }catch(e){
        messages.errorMessageGraph(e.error);
      }
    }    
  }
  private cuentasValidas(){
    var codigos = this.formValidacion.get('expresion')?.value || '' 
    const cod = codigos.match(/\d+/g) || [];
    const codigosCatalogo = this.dataCuentaContable.map(c => c.codigo);
    const codigosInvalidos = cod.filter(c => !codigosCatalogo.includes(c));
    if (codigosInvalidos.length > 0) {
      this.formValidacion.get('expresion')?.setErrors({ codigoInvalido: codigosInvalidos });
      return false;
    } else {
      this.formValidacion.get('expresion')?.setErrors(null);
    }
    return true;
  }
  public async opcionesValidacion(accion, val){
    try{
      if(accion === 'edit'){//editar una validacion 
        this.formValidacion.patchValue({
          nombre: val.description,
          expresion: val.expresion,
          id: val.validacionesid,
        });
        this.tituloModal = this.translate.instant('proyFinanciera.configCatalogo.editValidacion');
        document.getElementById('nuevaValidacion')!.style.display = 'block';        
      }else{ // eliminar una validacion 
        const result = await messages.confirmationSave(
          this.translate.instant('proyFinanciera.configCatalogo.deleteValidacion'),
          this.translate.instant('acciones.continuar'),
          this.translate
        );
        if(result){
          const res = await firstValueFrom(this.cuentaContable.deleteValidacion(val.validacionesid));
          this.dataValidaciones = this.dataValidaciones.filter(i=> i.validacionesid !== val.validacionesid);
          messages.succesMessageGraph(this.translate.instant('swal.swalElimino')); 
        }               
      }
    }catch(e){
      messages.errorMessageGraph(e.error)
    }
  }

  public exportar(tabla){
    messages.messageSaving(this.translate.instant('swal.generando'), this.translate.instant('swal.espere'))
    var titulos = [], alineacion = [], formato = [], data = [];
    var tituloHoja = '', nombreArch = '';
    if(tabla === 1){// tabla de contables
      titulos = [
        this.translate.instant('proyFinanciera.configCatalogo.titTab1'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab2'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab3'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab4'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab5'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab6'),
      ];
      alineacion = [Aligment.RIGHT, Aligment.LEFT, Aligment.RIGHT, Aligment.LEFT, Aligment.LEFT, Aligment.CENTER];
      formato = [FormatText.NUMBER, FormatText.TEXT, FormatText.NUMBER, FormatText.TEXT, FormatText.TEXT, FormatText.TEXT];
      for(const d of this.dataContable){
        var aux = [];
        aux.push(d.nivel);
        aux.push(d.tipoCuenta);
        aux.push(Number(d.codigo));
        aux.push(d.nombre);
        aux.push(d.proyeccion);
        aux.push(d.segmento);
        data.push(aux);
      }
    }
    if(tabla === 2){// tabla de extracontables
      titulos = [
        this.translate.instant('proyFinanciera.configCatalogo.titTab2'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab3'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab4'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab5'),
      ]
      alineacion = [Aligment.CENTER, Aligment.RIGHT, Aligment.LEFT, Aligment.LEFT];
      formato = [FormatText.TEXT, FormatText.NUMBER, FormatText.TEXT, FormatText.TEXT, FormatText.TEXT];
      for(const d of this.dataExtraCon){
        var aux = [];
        aux.push(d.tipoCuenta);
        aux.push(Number(d.codigo));
        aux.push(d.nombre);
        aux.push(d.proyeccion);
        data.push(aux);
      }
    }
    if(tabla === 3){// tabla de sucursales
      titulos = [
        this.translate.instant('proyFinanciera.configCatalogo.titTab3'),
        this.translate.instant('proyFinanciera.configCatalogo.titTab8'),
      ]
      alineacion = [Aligment.RIGHT, Aligment.LEFT];
      formato = [FormatText.NUMBER, FormatText.TEXT];
      for(const d of this.dataSucursales){
        var aux = [];
        aux.push(Number(d.codigo));
        aux.push(d.nombre);
        data.push(aux)
      }
    }
    tituloHoja = this.translate.instant('proyFinanciera.configCatalogo.titExcel'+tabla);
    nombreArch = this.translate.instant('proyFinanciera.configCatalogo.nombreArch'+tabla);
    this.excelservices.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }
}

